import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import LazyVideo from "@/components/LazyVideo"
import isExternalLink from "@/utils/is-external-link"
import { Link } from "@zestia/gatsby-plugin-react-i18next"

const SplitPane = ({
  assetAlignment,
  video,
  image,
  imageClass,
  kicker,
  title,
  titleClass = "h3",
  text,
  textClass = "mb-8 p--lg",
  link,
  linkClass = "text-link",
  children,
  className = "",
}) => {
  return (
    <section className={`split-pane container-fluid ${className}`}>
      <div
        className={`split-pane__inner row ${
          assetAlignment === "stacked"
            ? "center-xs"
            : "center-xs start-md middle-sm"
        }`}
      >
        <div
          className={`col-xs-12 col-md-6 ${
            assetAlignment === "left"
              ? "first-md"
              : assetAlignment === "stacked"
                ? "col-sm-8"
                : "col-md-offset-1"
          }`}
        >
          {video && <LazyVideo className="split-pane-asset" video={video} />}

          {image && (
            <GatsbyImage
              image={getImage(image.src)}
              alt={image.alt}
              className={`split-pane-asset ${imageClass ? imageClass : ""}`}
            />
          )}
        </div>

        <div
          className={`mt-10 md:mt-0 col-xs-12 ${
            assetAlignment === "right"
              ? "first-md col-md-5"
              : assetAlignment === "stacked"
                ? "col-sm-8"
                : "col-md-offset-1 col-md-5"
          }`}
        >
          <span className="heading-kicker">{kicker}</span>
          {title && <h2 className={titleClass}>{title}</h2>}
          {text && <p className={textClass}>{text}</p>}
          {link &&
            (isExternalLink(link.url) ? (
              <a className={linkClass} href={`${link.url}`}>
                <b>{link.text}</b>
              </a>
            ) : (
              <Link
                to={link.url}
                className={linkClass}
                language={link.language}
              >
                {link.text}
              </Link>
            ))}

          {children}
        </div>
      </div>
    </section>
  )
}

export default SplitPane
